(() => {
  if (window.__pwCartPageV4Bound) return;
  window.__pwCartPageV4Bound = true;

  const pageRoot = () => document.querySelector('[data-pw-cart-page]');
  const noteDialog = () => document.getElementById('cart-page-note');

  function openNoteDialog() {
    const dialog = noteDialog();
    if (!(dialog instanceof HTMLDialogElement)) return;

    const agree = dialog.querySelector('[data-pw-cart-page-note-agree]');
    const error = dialog.querySelector('[data-pw-cart-page-note-error]');
    const inner = dialog.querySelector('.pw-cart-page-note__inner');

    if (agree) agree.checked = false;
    if (error) error.hidden = true;
    if (inner) inner.scrollTop = 0;

    if (!dialog.open) {
      dialog.showModal();
    }
  }

  function closeNoteDialog() {
    const dialog = noteDialog();
    if (dialog instanceof HTMLDialogElement && dialog.open) {
      dialog.close();
    }
  }

  document.addEventListener('click', (event) => {
    const page = pageRoot();
    if (!page && !event.target.closest('#cart-page-note')) return;

    const minus = event.target.closest('[data-pw-cart-page-minus]');
    const plus = event.target.closest('[data-pw-cart-page-plus]');

    if (minus || plus) {
      const stepper = (minus || plus).closest('[data-pw-cart-page-stepper]');
      const input = stepper && stepper.querySelector('input.quantity-input[data-line-key]');
      if (!input) return;

      const min = Math.max(1, parseInt(input.min || '1', 10) || 1);
      const max = Math.min(5, parseInt(input.max || '5', 10) || 5);
      let value = parseInt(input.value || '1', 10) || 1;

      value += plus ? 1 : -1;
      value = Math.max(min, Math.min(max, value));
      if (String(value) === String(input.value)) return;

      input.value = value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (event.target.closest('[aria-controls="cart-page-note"]')) {
      openNoteDialog();
      return;
    }

    if (event.target.closest('[data-pw-cart-page-note-close]')) {
      closeNoteDialog();
      return;
    }

    const dialog = event.target.closest('dialog#cart-page-note');
    if (dialog && event.target === dialog) {
      closeNoteDialog();
      return;
    }

    const save = event.target.closest('[data-pw-cart-page-note-save]');
    if (!save) return;

    const form = save.closest('[data-pw-cart-page-note-form]');
    const textarea = form && form.querySelector('[data-pw-cart-page-note-textarea]');
    const agree = form && form.querySelector('[data-pw-cart-page-note-agree]');
    const error = form && form.querySelector('[data-pw-cart-page-note-error]');
    if (!textarea || !agree) return;

    const note = textarea.value.trim();

    if (note && !agree.checked) {
      if (error) error.hidden = false;
      agree.focus();
      return;
    }

    if (error) error.hidden = true;
    save.disabled = true;
    save.setAttribute('aria-busy', 'true');

    const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(shopRoot + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to save delivery note');
        return response.json();
      })
      .then(() => {
        closeNoteDialog();
      })
      .catch((error) => console.error(error))
      .finally(() => {
        save.disabled = false;
        save.removeAttribute('aria-busy');
      });
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches('input.quantity-input[data-line-key]')) {
      let value = parseInt(event.target.value || '1', 10) || 1;
      const max = Math.min(5, parseInt(event.target.max || '5', 10) || 5);
      value = Math.max(1, Math.min(max, value));
      event.target.value = value;
    }

    if (event.target.matches('[data-pw-cart-page-note-agree]') && event.target.checked) {
      const form = event.target.closest('[data-pw-cart-page-note-form]');
      const error = form && form.querySelector('[data-pw-cart-page-note-error]');
      if (error) error.hidden = true;
    }
  });

  document.addEventListener('cancel', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.id === 'cart-page-note') {
      event.preventDefault();
      event.target.close();
    }
  }, true);
})();
